import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '~/components';
import QBO from '~/routes/app/projects/assets/qbo.svg?react';

const Icon = styled(QBO)`
  width: 1rem;
  height: 1rem;
  display: block;
`;

export default function QBOExpenseIndicator({ message }) {
  return (
    <Tooltip message={message ?? 'This expense is in QuickBooks.'}>
      <Icon />
    </Tooltip>
  );
}
